/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} First_MatchdayInputs */

const th_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันแข่งวันแรก`)
};

const en_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First matchday`)
};

const ja_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初戦の日`)
};

const zh_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首个比赛日`)
};

const es_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primera jornada`)
};

const pt_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeira rodada`)
};

const id_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hari pertandingan pertama`)
};

const fr_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Première journée`)
};

const tl_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unang araw ng laro`)
};

const vi_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vòng đầu tiên`)
};

const ko_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 경기일`)
};

const de_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erster Spieltag`)
};

const ru_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Первый игровой день`)
};

const tr_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk maç günü`)
};

const it_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima giornata`)
};

const pl_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pierwsza kolejka`)
};

const uk_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перший ігровий день`)
};

const hi_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहला मैच दिवस`)
};

const ar_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أول يوم مباريات`)
};

const ms_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hari perlawanan pertama`)
};

const bn_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রথম খেলার দিন`)
};

const zh_tw2_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首個比賽日`)
};

const zh_hk2_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首個比賽日`)
};

const ur_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پہلا میچ ڈے`)
};

const fa_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نخستین روز بازی`)
};

const sw_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siku ya kwanza ya michezo`)
};

const nl_first_matchday = /** @type {(inputs: First_MatchdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerste speeldag`)
};

/**
* | output |
* | --- |
* | "First matchday" |
*
* @param {First_MatchdayInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const first_matchday = /** @type {((inputs?: First_MatchdayInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<First_MatchdayInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_first_matchday(inputs)
	if (locale === "ja") return ja_first_matchday(inputs)
	if (locale === "zh") return zh_first_matchday(inputs)
	if (locale === "es") return es_first_matchday(inputs)
	if (locale === "pt") return pt_first_matchday(inputs)
	if (locale === "id") return id_first_matchday(inputs)
	if (locale === "fr") return fr_first_matchday(inputs)
	if (locale === "tl") return tl_first_matchday(inputs)
	if (locale === "vi") return vi_first_matchday(inputs)
	if (locale === "ko") return ko_first_matchday(inputs)
	if (locale === "de") return de_first_matchday(inputs)
	if (locale === "ru") return ru_first_matchday(inputs)
	if (locale === "tr") return tr_first_matchday(inputs)
	if (locale === "it") return it_first_matchday(inputs)
	if (locale === "pl") return pl_first_matchday(inputs)
	if (locale === "uk") return uk_first_matchday(inputs)
	if (locale === "hi") return hi_first_matchday(inputs)
	if (locale === "ar") return ar_first_matchday(inputs)
	if (locale === "ms") return ms_first_matchday(inputs)
	if (locale === "bn") return bn_first_matchday(inputs)
	if (locale === "zh-TW") return zh_tw2_first_matchday(inputs)
	if (locale === "zh-HK") return zh_hk2_first_matchday(inputs)
	if (locale === "ur") return ur_first_matchday(inputs)
	if (locale === "fa") return fa_first_matchday(inputs)
	if (locale === "sw") return sw_first_matchday(inputs)
	if (locale === "nl") return nl_first_matchday(inputs)
	return en_first_matchday(inputs)
});